import { normalizeApiError } from '../api/apiError';

const MESSAGES: Record<string, string> = {
  INVALID_REPORT_CODE: 'Report was not found.',
  REPORT_NOT_FOUND: 'Report was not found.',
  REPORT_NOT_ALLOWED: 'You do not have permission to run this report.',
  REPORT_FILTER_INVALID: 'Check the selected report filters.',
  REPORT_DATE_RANGE_TOO_LARGE: 'Select a smaller date range.',
  REPORT_RESULT_TOO_LARGE:
    'The report is too large to preview. Download an export instead.',
  REPORT_TOO_LARGE:
    'The report is too large to preview. Download an export instead.',
  REPORT_EXPORT_NOT_SUPPORTED: 'This export format is not available.',
  INVALID_REPORT_FORMAT: 'This export format is not available.',
  REPORT_EXECUTION_NOT_FOUND: 'Report execution was not found.',
  REPORT_FILE_NOT_AVAILABLE: 'The report file is no longer available.',
  REPORT_GENERATION_FAILED: 'The report could not be generated.',
  REPORT_EXPORT_LIMIT_REACHED:
    'Too many report exports are currently running. Try again later.',
  REQUEST_TIMEOUT: 'Report generation took too long.',
  ACCESS_DENIED: 'You do not have permission to access this report.',
  VALIDATION_ERROR: 'Check the selected report filters.',
  NETWORK_ERROR: 'Unable to connect to the server.',
  REPORT_STORAGE_UNAVAILABLE: 'Report storage is unavailable.',
  REPORT_FILE_WRITE_FAILED: 'The report could not be saved.',
  REPORT_FILE_INVALID: 'The downloaded report is invalid.',
  REPORT_OPEN_NOT_SUPPORTED:
    'No compatible application is available to open this report.',
  REPORT_SHARE_FAILED: 'The report could not be shared.',
  REPORT_DOWNLOAD_CANCELED: 'The report download was canceled.',
  PDF_GENERATOR_UNAVAILABLE:
    'PDF download is unavailable on the server. Please contact your administrator.',
  PROJECT_REPORT_NOT_INSTALLED:
    'The project task report is not set up on the server. Please contact your administrator.',
  EMPLOYEE_PROFILE_REQUIRED: 'An employee profile is required to view this report.',
  PROJECT_NOT_FOUND: 'Project was not found.',
};

export function reportErrorMessage(
  error: unknown,
  fallback = 'Unable to load reports.',
): string {
  if (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    typeof (error as { code?: unknown }).code === 'string'
  ) {
    const code = (error as { code: string }).code;
    if (MESSAGES[code]) return MESSAGES[code];
  }

  const apiError = normalizeApiError(error);
  if (apiError.code && MESSAGES[apiError.code]) {
    return MESSAGES[apiError.code];
  }
  return fallback;
}
